module.exports = __webpack_public_path__ + "static/media/zen-logo.2f25c81d.png";